import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";
import { accountIdFormat } from "../../ids";
import { BrandAliasSchema } from "./brand-alias";
import { MinimalBrandCompetitorSchema } from "./brand-competitor";

export const BrandIdentityGuideSchema = z.object({
  accountId: accountIdFormat.schema,
  name: z.string(),
  storefrontUrl: z.string(),
  headquarters: z.string(),
  foundedDate: z.date(),
  industry: z.string(),
  companyDescription: z.string(),
  brandVoice: z.string(),
  missionStatement: z.string(),
  marketPosition: z.string(),
  competitiveDifferentiation: z.string(),
  companyValues: z.array(z.string()),
  targetAudience: z.string(),
  contentStrategy: z.string(),
  brandKeywords: z.string(),
  competitors: z.array(MinimalBrandCompetitorSchema),
  brandAliases: z.array(BrandAliasSchema),
});
export type BrandIdentityGuide = z.infer<typeof BrandIdentityGuideSchema>;

export const brandIdentityGuideGeneratedFieldNames = [
  "headquarters",
  "foundedDate",
  "industry",
  "companyDescription",
  "brandVoice",
  "missionStatement",
  "marketPosition",
  "competitiveDifferentiation",
  "companyValues",
  "targetAudience",
  "contentStrategy",
  "brandKeywords",
  "competitors",
  "brandAliases",
] as const;

export type BrandIdentityGuideGeneratedFieldName =
  (typeof brandIdentityGuideGeneratedFieldNames)[number];

export const BrandIdentityGuideGeneratedFieldNameSchema = createEnum(
  brandIdentityGuideGeneratedFieldNames,
);
